import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CorpForm from './CorpForm';
import { fetchWithCorpId } from '../utils/api';
import PageHeader from './ui/PageHeader';
import { FormLoading } from './ui/formkit';

function CorpFormScreen({ mode, onSuccess, onCancel }) {
  const { id } = useParams();
  const isEdit = mode === 'edit';
  const [corpData, setCorpData] = useState(null);
  const [loading, setLoading] = useState(isEdit);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCorp = async () => {
      if (mode === 'edit' && id) {
        setLoading(true);
        try {
          const data = await fetchWithCorpId(`/corps/${id}`);
          setCorpData(data);
        } catch (err) {
          console.error('Error fetching corporation:', err);
          setError('Failed to load corporation data');
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    fetchCorp();
  }, [mode, id]);

  return (
    <div className="page-container">
      <PageHeader
        backTo="/on/corps"
        backLabel="Back to Corporations"
        title={isEdit ? 'Edit corporation' : 'New corporation'}
      />
      <div className="card" style={{ maxWidth: '880px' }}>
        <div className="card-body">
          {loading && <FormLoading label="Loading corporation…" />}
          {!loading && error && (
            <div className="alert error" role="alert">{error}</div>
          )}
          {!loading && !error && (
            <CorpForm
              mode={mode}
              initialData={corpData}
              onSuccess={onSuccess}
              onCancel={onCancel}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default CorpFormScreen;
